import { createTranslationMessages } from '@backstage/core-plugin-api/alpha';
import { scaffolderReactTranslationRef } from '@backstage/plugin-scaffolder-react/alpha';

export const scaffolderReactFr = createTranslationMessages({
  ref: scaffolderReactTranslationRef,
  full: true,
  messages: {
    'workflow.noDescription': 'Aucune description',
    'passwordWidget.content':
      "Ce widget n'est pas sécurisé. Veuillez utiliser [`ui:field: Secret`](https://backstage.io/docs/features/software-templates/writing-templates/#using-secrets) au lieu de `ui:widget: password`",
    'scaffolderPageContextMenu.createLabel': 'Créer',
    'scaffolderPageContextMenu.moreLabel': 'plus',
    'scaffolderPageContextMenu.editorLabel': 'Gérer les modèles',
    'scaffolderPageContextMenu.actionsLabel': 'Actions installées',
    'scaffolderPageContextMenu.tasksLabel': 'Liste des tâches',
    'scaffolderPageContextMenu.templatingExtensionsLabel':
      'Extensions de templating',
    'stepper.backButtonText': 'Retour',
    'stepper.createButtonText': 'Créer',
    'stepper.reviewButtonText': 'Vérification',
    'stepper.nextButtonText': 'Suivant',
    'stepper.stepIndexLabel': 'Étape {{index, number}}',
    'templateCategoryPicker.title': 'Catégories',
    'templateCard.noDescription': 'Aucune description',
    'templateCard.chooseButtonText': 'Choisir',
    'cardHeader.detailBtnTitle': "Afficher les détails de l'entité du modèle",
    'templateOutputs.title': 'Sortie texte',
  },
});
